const TOKEN_KEY = "scriptcompass_token";
const USER_KEY = "scriptcompass_user";
const SELECTED_ACCOUNT_KEY = "scriptcompass_selected_account"; // MA-PHASE11A-P0: Account context

export function setAuth(token, user) {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(USER_KEY, JSON.stringify(user));
}

/**
 * MA-SESSION-CACHE-ISOLATION-117B: Hard logout reset
 * 
 * Clears ALL auth-related state to ensure deterministic session isolation.
 * MUST be paired with React Query cache clear in logout handler.
 */
export function clearAuth() {
  // Clear core auth tokens
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
  localStorage.removeItem(SELECTED_ACCOUNT_KEY); // MA-PHASE11A-P0: Clear account context on logout
  
  // MA-SESSION-CACHE-ISOLATION-117B: Clear navigation state
  localStorage.removeItem("last_path_leads");
  localStorage.removeItem("last_path_appointments");
  
  // sessionStorage cleanup (defensive - not currently used for auth)
  sessionStorage.clear();
}

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function getStoredUser() {
  const raw = localStorage.getItem(USER_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

/**
 * MA-PHASE11A-P0-FRONTEND-ACCOUNT-CONTEXT-HEADER-001:
 * Store selected account ID for API interceptor to attach as X-Account-ID header
 */
export function setSelectedAccountId(accountId) {
  if (accountId) {
    localStorage.setItem(SELECTED_ACCOUNT_KEY, accountId);
  } else {
    localStorage.removeItem(SELECTED_ACCOUNT_KEY);
  }
}

/**
 * MA-PHASE11A-P0-FRONTEND-ACCOUNT-CONTEXT-HEADER-001:
 * Get selected account ID for API interceptor
 */
export function getSelectedAccountId() {
  return localStorage.getItem(SELECTED_ACCOUNT_KEY);
}
